import useCustomer from "../../hooks/useCustomer";

const useObservationCustomerForm = () => {
  const { onSelectCustomer, onNewCustomer, onEditCustomer, onRemoveCustomer } =
    useCustomer();

  const onSelect = (customerId) => onSelectCustomer(customerId);

  const handleNewCustomer = (customer) => onNewCustomer(customer);

  const handleEditCustomer = (customer) => onEditCustomer(customer);

  const handleRemoveCustomer = () => onRemoveCustomer();

  const handleExists = (response) => handleNewCustomer(response.data[0]);

  return {
    onSelect,
    handleExists,
    handleNewCustomer,
    handleEditCustomer,
    handleRemoveCustomer,
  };
};

export default useObservationCustomerForm;
